/* eslint-disable no-console */
import iosShareIcon from '../assets/icons/pwa/ios-share.svg';
import Tracker from '../scripts/tracking';

const manifestpath = '/site.webmanifest';
const iosInstallInfotext = `Drücke den Teilen-Button <img src="/assets/${iosShareIcon.__file}" />und dann 'Zum Home-Bildschirm'`;
const androidInstallInfotext = 'Zum Home-Bildschirm hinzufügen';
const closeButtonHTML = `<button class="close-button" id="close-prompt-btn">
                            <span class="sr-only">Close</span>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512" fill="currentColor">
                            <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/></svg>
                        </button>`;

let addBtn: HTMLButtonElement;
let closeBtn: HTMLButtonElement;
let installPrompt: HTMLElement;
let installAppPromptUserChoice;
let deferredPrompt;

interface ManifestData {
    name: string;
    // eslint-disable-next-line camelcase
    start_url: string;
    // eslint-disable-next-line camelcase
    short_name: string;
    description: string;
    screenshots: Array<any>;
    features: Array<any>;
    icons: Array<any>;
}

(function () {
    async function getManifestData (): Promise<ManifestData | null> {
        try {
            const response = await fetch(manifestpath);
            const data = await response.json();

            const manifestData = data;

            if (manifestData) {
                checkManifest(manifestData);

                return data;
            }
        } catch (err) {
            // Error message is in the try...catch on getManifestData check
        }

        return null;
    }

    function checkManifest (manifestData: ManifestData): void {
        if (!manifestData.icons || !manifestData.icons[0]) {
            console.error('Your web manifest must at least have one icon listed');
            return;
        }

        if (!manifestData.name) {
            console.error('Your web manifest must have a name listed');
            return;
        }

        if (!manifestData.start_url) {
            console.error('Your web manifest must at least have a start_url like /');
        }
    }

    if (manifestpath) {
        try {
            getManifestData();
        } catch (err) {
            console.error(
                'Error getting manifest, check that you have a valid web manifest'
            );
        }
    }

    // Fallback for iOS as it does not support browser install prompt
    const isIOS =
      navigator.userAgent.includes('iPhone') ||
      navigator.userAgent.includes('iPad') ||
      (navigator.userAgent.includes('Macintosh') &&
        typeof navigator.maxTouchPoints === 'number' &&
        navigator.maxTouchPoints > 2);

    // Check if app is in standalone mode on iOS.
    const showInstallPrompt = ('standalone' in navigator && (navigator as any).standalone === false);

    installAppPromptUserChoice = localStorage.getItem('installAppPromptUserChoice') || null;

    function loadInstallPromptMarkup (): HTMLElement | void {
        if (installAppPromptUserChoice === 'dismissed') return;

        installPrompt = document.createElement('div');

        installPrompt.classList.add('install-prompt');

        installPrompt.innerHTML = isIOS ? renderHTMLIOS() : renderHTMLAndroid();
        document.body.appendChild(installPrompt);
        addBtn = document.querySelector('#add-to-home-btn');
        closeBtn = document.querySelector('#close-prompt-btn');

        // As beforeinstallprompt is not supported we have to check via standalone mode if the app is already installed
        if (isIOS && showInstallPrompt) {
            installPrompt.classList.add('install-prompt-ios');
            installPrompt.style.display = 'flex';
        }
    }

    loadInstallPromptMarkup();

    window.addEventListener('beforeinstallprompt', (event) => {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        event.preventDefault();

        if (installAppPromptUserChoice === 'dismissed') return;
        // Stash the event so it can be triggered later.
        deferredPrompt = event;
        // Update UI to notify the user they can add to home screen
        installPrompt.style.display = 'flex';

        addBtn?.addEventListener('click', () => {
            Tracker.trackEvent({
                category: 'pwa-install',
                action: 'add-to-homescreen',
                name: 'android',
            });
            // Show the prompt
            deferredPrompt.prompt();
            // Wait for the user to respond to the prompt
            deferredPrompt.installAppPromptUserChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    installPrompt.style.display = 'none';
                    localStorage.setItem('installAppPromptUserChoice', 'accepted');
                } else {
                    installPrompt.style.display = 'none';
                    localStorage.setItem('installAppPromptUserChoice', 'dismissed');
                }
                deferredPrompt = null;
            });
        });
    });

    closeBtn?.addEventListener('click', () => {
        installPrompt.style.display = 'none';
        localStorage.setItem('installAppPromptUserChoice', 'dismissed');
    });

    document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
            installPrompt.style.display = 'none';
            localStorage.setItem('installAppPromptUserChoice', 'dismissed');
        }
    });

    function renderHTMLAndroid (): string {
        return `
            <img src="/assets/assets/images/fes-logo-mobile.svg" width="44" alt="FES-Logo">
            <button class="add-button" id="add-to-home-btn">
                <span class="android-description">
                    ${androidInstallInfotext}
                </span>
            </button>

            ${closeButtonHTML}
        `;
    }

    function renderHTMLIOS (): string {
        return `
            <div class="ios-wrapper">
                <span class="ios-description">
                    ${iosInstallInfotext}
                </span>

                ${closeButtonHTML}
            </div>
        `;
    }

    function getInstallStatus () {
        if (isIOS && !showInstallPrompt) {
            Tracker.trackEvent({
                category: 'pwa-install',
                action: 'app-installed',
                name: 'iOS in Standalone mode',
            });
        }

        window.addEventListener('appinstalled', () => {
            Tracker.trackEvent({
                category: 'pwa-install',
                action: 'app-installed',
                name: 'Installed on Android',
            });
        });
    }
    getInstallStatus();
})();
